import { Link } from "@tanstack/react-router";
import { Compass } from "lucide-react";

import { EmptyState, buttonClass } from "@/components/ui";

export function NotFound() {
  return (
    <EmptyState
      icon={Compass}
      title="Page not found"
      className="min-h-[60dvh]"
      action={
        <Link to="/" className={buttonClass("secondary", "sm")}>
          Go to the market overview
        </Link>
      }
    >
      The link may be old, or the page hasn't been built yet.
    </EmptyState>
  );
}
